import React, {Component, Fragment} from 'react';
import { connect }        from 'react-redux';
import { NavLink } from 'react-router-dom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import * as routs from '../../../../constants/routes';
import {createFiltersUrl, getFullMediaUrl} from "../../../../app/static_func";

//actions
import { getCarsByQuery } from 'redux/actions';

//components
import Slider from 'react-slick';
import Autocomplete from 'components/forms/autocomplete';
import Favorites from './favorites/favorites';

//assets
import './search.scss';
import car from 'assets/mock/car.jpg';
import talkToUs from 'assets/icons/talk_to_us.svg';
import magnifyingGlass from 'assets/icons/magnifying_glass.svg';
import deleteIcon from 'assets/icons/close_icon.svg';
import blueArrow from 'assets/icons/arrow_down_blue.svg';
import searchIcon from 'assets/icons/search_icon.svg';


class Search extends Component {

    constructor(props) {
        super(props);
        this.state = {
            query: '',
            searchOpen:false
        }

        this.handleQueryInput = this.handleQueryInput.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleDeleteTextClick = this.handleDeleteTextClick.bind(this);
        this.handleSearchClick = this.handleSearchClick.bind(this);
        this.handleAutocomleteOptionOnSelect = this.handleAutocomleteOptionOnSelect.bind(this);
        this.handleSearchBtnClick = this.handleSearchBtnClick.bind(this);

        this.searchRef = React.createRef();
    }

    handleSearchBtnClick(){
        this.props.history.push(routs.results + '/'+ (this.state.query!==''?'query=' + this.state.query : ''));
    }

    handleClickOutside(){
        this.setState({options:[]});
    }

    handleDeleteTextClick(){
        this.setState({query:'',options:[]});
    }

    //returns all the matching options for the current query

    handleQueryInput(query) {

        this.props.getCarsByQuery({'query': query.target.value});

        if(this.props.deviceState !== 'desktop_large')
            window.scrollTo(0, this.searchRef.current.offsetTop - 90);
        else
            window.scrollTo(0, this.searchRef.current.offsetTop - 440);

        this.setState({query:query.target.value });
    }

    handleSearchClick(){
        this.setState({searchOpen:true})
    }

    getOptions(){
        const options = this.props.options;
        let results = [];
        if(options) {
            options.forEach((item,index) => {
                item.id = index;
                results.push(item);
            });
        }
        return results;
    }

    getCarCategories(){
        const options = this.props.carCategories;
        let results = [];
        if(options.length > 0) {
            options.map(item => (
                results.push(
                    <div className='mySlide' key={item.id}>
                        <NavLink to={routs.results + '/category_id=' + item.id} className="slide" key='link1'>
                            <img className="car" src={item.image.path!== '' ? getFullMediaUrl(item.image.path) : car} alt={item.image.alt}/>
                            <div className="text">{item.title}</div>
                        </NavLink>
                    </div>)
            ));
        }

        return results;
    }

    getPriceStairs(){
        const options = this.props.priceStairs;
        let results = [];
        if(options.length > 0) {
            options.map(item => (
                results.push(
                    <div className='mySlide' key={item.id}>
                        <NavLink to={routs.results + '/price_stairs_id=' + item.id} className="slide" key='link1'>
                            <img className="car" src={item.image.path!== '' ? getFullMediaUrl(item.image.path) : car} alt={item.image.alt}/>
                            <div className="text">{item.title}</div>
                        </NavLink>
                    </div>)
            ));
        }

        return results;
    }

    handleAutocomleteOptionOnSelect(res){
        //route to results page with URL params
        this.props.history.push(routs.results + '/' + createFiltersUrl(res.filters));
    }

    render() {
        const text = this.props.text;

        const firstEnterence = false;
        const is_mobile = this.props.deviceState === 'mobile';
        const is_tablet = this.props.deviceState === 'tablet';
        const is_laptop = this.props.deviceState === 'desktop';
        const isLaptopOrDesktop = this.props.deviceState === 'desktop' || this.props.deviceState === 'desktop_large';

        let slideToShow;
        let firstDotIndex;
        let dots;
        let arrows;

        if (is_mobile) {
            slideToShow = 1.4;
            firstDotIndex = this.getCarCategories().length-1;
            dots = true;
            arrows = false;
        }

        else if(is_tablet) {
            slideToShow = 2.4;
            firstDotIndex = this.getCarCategories().length - (Math.floor(slideToShow));
            dots = true;
            arrows = false;
        }

        else{
            if(is_laptop)
                slideToShow = 3;
            else
                slideToShow = 4.3;
            firstDotIndex = this.getCarCategories().length - (Math.floor(slideToShow));
            dots = false;
            arrows = true;
        }


        const settings = {
            dots: dots,
            infinite: false,
            speed: 500,
            slidesToShow: slideToShow,
            slidesToScroll: 1,
            rtl:true,
            initialSlide:firstDotIndex,
            arrows:arrows,
            prevArrow:<ArrowPrev/>,
            nextArrow:<ArrowNext/>
        };

        const settingsStairs = {
            dots: dots,
            infinite: false,
            speed: 500,
            slidesToShow: slideToShow,
            slidesToScroll: 1,
            rtl:true,
            initialSlide:this.getPriceStairs().length - (Math.floor(slideToShow)),
            arrows:arrows,
            prevArrow:<ArrowPrev/>,
            nextArrow:<ArrowNext/>
        };


        const isFavorites = true;

        return (
            <section className="search" ref = { this.searchRef }>
                {!firstEnterence && (is_mobile || is_tablet) &&
                <Fragment>
                    <div className='autoCompleteWrapper'>
                        <div className='deleteText' onClick={()=> this.handleDeleteTextClick()}>
                            <img className='deleteIcon' src={deleteIcon} alt='\'/>
                            <div className='divider'/>
                        </div>
                        <Autocomplete
                            className='autoComplete'
                            options={this.getOptions()}
                            placeholder={<span><strong>חיפוש</strong> יצרן,דגם,או מילת מפתח</span>}
                            query={this.state.query}
                            onChange={this.handleQueryInput}
                            onClickOutside={this.handleClickOutside}
                            customPlaceholder = {true}
                            onSelect = {this.handleAutocomleteOptionOnSelect}
                            link = {routs.results}
                        />
                        <span className='searchIcon' onClick={this.handleSearchBtnClick}>
                            <img src={magnifyingGlass} alt='/' className='glassIcon'/>
                        </span>
                    </div>
                    <Favorites history={this.props.history}/>
                </Fragment>
                }
                {(!is_mobile && !is_tablet) &&
                <div className='manualSearch'>
                    <Autocomplete
                        className='autoComplete'
                        options={this.getOptions()}
                        placeholder=''
                        query={this.state.query}
                        onChange={this.handleQueryInput}
                        onClickOutside={this.handleClickOutside}
                        customPlaceholder={<div>
                            <img src={searchIcon} alt='\' className='searchIcon'/>
                            <span><strong> &nbsp; חיפוש &nbsp;  </strong>
                           </span>יצרן, דגם, או מילת מפתח
                        </div>}
                        onSelect={this.handleAutocomleteOptionOnSelect}
                        link={routs.results}
                        onEnterClick={this.handleSearchBtnClick}

                    />
                    <span  className="manualSearchBtn" onClick ={this.handleSearchBtnClick}>חיפוש</span>
                </div>
                }
                {(!is_mobile && !is_tablet) &&
                    <Favorites history={this.props.history}/>
                }
                    <div className="types">
                        <div className="title">
                            <span className="position">{text['search_badget']}</span>
                            <div className='underline'/>
                        </div>
                        {(this.getPriceStairs().length > 0) &&
                        <Slider className="categories" {...settingsStairs}>
                            {this.getPriceStairs()}
                        </Slider>
                        }
                    </div>

                <div className="types">
                    <div className="title">
                        <span className="position">{text['search_use_case']}</span>
                        <div className='underline'/>
                    </div>
                    {(this.getCarCategories().length > 0) &&
                    <Slider className="categories" {...settings}>
                        {this.getCarCategories()}
                    </Slider>
                    }
                </div>

                <div className="buttons sec-ent">
                    <NavLink to={routs.placeholder} className="match">{text['search_match_btn']}</NavLink>
                    <NavLink to={routs.results} className="search_btn">{text['search_view_all_cars']}</NavLink>
                    {isLaptopOrDesktop && !isFavorites &&
                    <img src={talkToUs} className='talkIcon' alt='\'/>
                    }
                </div>
            </section>
        );
    }
}

//add GD categories and deviceState to props
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        webMode: store.config.WebMode,
        carCategories: store.config.CarCategories,
        priceStairs: store.config.PriceStairs,
        options: store.data.AutoCompleteResults,
        text: store.config.Translations,
    }
}
//map a doLgin function to props
const mapDispatchToProps = dispatch => {
    return {
        getCarsByQuery: (payload) => dispatch(getCarsByQuery(payload)),
    }
}

//connect to redux store - maps dispatch and redux state to props
export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(Search);


function ArrowPrev(props) {
        return (
            <div className={props.className} onClick={props.onClick}>
                <img src={blueArrow} alt='/'/>
            </div>
        );
}

function ArrowNext(props) {
        return (
            <div className={props.className} onClick={props.onClick}>
                <img  src={blueArrow} alt='/'/>
            </div>
        );

}